import Fingerprint from '@fingerprint/agent'

const API_KEY = process.env.REACT_APP_FINGERPRINT_API_KEY

const agentPromise = Fingerprint.start({
  apiKey: API_KEY,
  region: 'us',
  endpoints: ['https://pickwin.mx/nCvTEJMOIjt6LobR/'],
})

/** @returns {Promise<{ event_id: string, visitor_id: string }>} */
export const getFingerprint = async () => await agentPromise.get()
